<template>
  <div>
    <div v-if="!inline" class="modal-card" style="width: auto">
      <section v-if="adType !== AdType.None" class="modal-card-body">
        <div v-if="adType === AdType.Google && googleCreatives" class="card-frame _ngcontent-rsq-30">
          <div class="card-content _ngcontent-rsq-30">
            <div class="ad-carousel-frame _ngcontent-rsq-30">
              <div class="ad-carousel _ngcontent-rsq-30" style="margin-left: 0px">
                <div class="ad-carousel-item _ngcontent-rsq-30">
                  <div class="device _ngcontent-rsq-30 desktop-device">
                    <div class="ad _ngcontent-rsq-30">
                      <div class="header-wrapper _ngcontent-rsq-30">
                        <div class="ad-preview-header _ngcontent-rsq-30">
                          <div
                            v-if="googleCreatives.HeadlinePart1 || googleCreatives.HeadlinePart2"
                            class="header-link _ngcontent-rsq-30"
                          >
                            <span class="_ngcontent-rsq-30">
                              <span class="_ngcontent-rsq-30">
                                {{ googleCreatives.HeadlinePart1 }}
                              </span>
                            </span>
                            <span class="_ngcontent-rsq-30">
                              <span class="_ngcontent-rsq-30"></span>
                            </span>
                            <span class="_ngcontent-rsq-30">
                              <span class="_ngcontent-rsq-30">|</span>
                            </span>
                            <span class="_ngcontent-rsq-30">
                              <span class="_ngcontent-rsq-30"></span>
                            </span>
                            <span class="_ngcontent-rsq-30">
                              <span class="_ngcontent-rsq-30">{{ googleCreatives.HeadlinePart2 }}</span>
                            </span>
                          </div>
                          <div class="url-container _ngcontent-rsq-30">
                            <div class="display-url _ngcontent-rsq-30">
                              <div class="ad-icon _ngcontent-rsq-30">Ad</div>
                              <span class="domain-url _ngcontent-rsq-30">
                                {{ googleCreatives.FinalUrl }}
                              </span>
                              <span class="_ngcontent-rsq-30"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="subheader _ngcontent-rsq-30">
                        <div class="subheader-item display-url-container _ngcontent-rsq-30"></div>
                      </div>
                      <div class="subheader _ngcontent-rsq-30">
                        <div class="subheader-item _ngcontent-rsq-30">
                          <div class="description _ngcontent-rsq-30">
                            <span class="_ngcontent-rsq-30">
                              <span class="_ngcontent-rsq-30">{{ googleCreatives.Description }}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-if="adType === AdType.Facebook && facebookAd" v-html="facebookAd"></div>
      </section>
      <footer v-if="adType !== AdType.None && !hideFooter" class="modal-card-foot">
        <b-button :label="$t('Close')" type="is-primary" @click="close()" />
      </footer>
    </div>
    <div v-if="inline">
      <div v-if="adType === AdType.Google && googleCreatives">
        <div class="ad _ngcontent-rsq-30">
          <div class="header-wrapper _ngcontent-rsq-30">
            <div class="ad-preview-header _ngcontent-rsq-30">
              <div v-if="googleCreatives.HeadlinePart1 || googleCreatives.HeadlinePart2" class="header-link _ngcontent-rsq-30">
                <span class="_ngcontent-rsq-30">
                  <span class="_ngcontent-rsq-30">{{ googleCreatives.HeadlinePart1 }}</span>
                </span>
                <span class="_ngcontent-rsq-30"><span class="_ngcontent-rsq-30"> </span></span>
                <span class="_ngcontent-rsq-30"><span class="_ngcontent-rsq-30">|</span></span>
                <span class="_ngcontent-rsq-30"><span class="_ngcontent-rsq-30"> </span></span>
                <span class="_ngcontent-rsq-30">
                  <span class="_ngcontent-rsq-30">{{ googleCreatives.HeadlinePart2 }}</span>
                </span>
              </div>
              <div class="url-container _ngcontent-rsq-30">
                <div class="display-url _ngcontent-rsq-30">
                  <div class="ad-icon _ngcontent-rsq-30">Ad</div>
                  <span class="domain-url _ngcontent-rsq-30">{{ googleCreatives.FinalUrl }}</span>
                  <span class="_ngcontent-rsq-30"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="subheader _ngcontent-rsq-30">
            <div class="subheader-item display-url-container _ngcontent-rsq-30"></div>
          </div>
          <div class="subheader _ngcontent-rsq-30">
            <div class="subheader-item _ngcontent-rsq-30">
              <div class="description _ngcontent-rsq-30">
                <span class="_ngcontent-rsq-30">
                  <span class="_ngcontent-rsq-30">{{ googleCreatives.Description }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-if="adType === AdType.Facebook && facebookAd" v-html="facebookAd"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { GoogleCreatives } from "@/models/GoogleCreatives";
import { Result } from "@/models/Result";
import HelperService from "@/services/HelperService";
import ApiService from "@/services/api/ApiService";

@Component({})
export default class AdPreview extends Vue {
  @Prop() readonly adGroupId!: number;
  @Prop() readonly adId!: number;
  @Prop() readonly channelId!: number;
  @Prop() readonly inline!: boolean;
  @Prop() readonly hideFooter!: boolean;

  facebookAd = "";
  adType = AdType.None;
  googleCreatives: GoogleCreatives | null = null;

  AdType = AdType;

  mounted(): void {
    let loader = this.$loading.show({
      container: this.$refs.leadsTableContainer,
    });
    ApiService.getAdPreviewData(this.adId, this.adGroupId, this.channelId)
      .then((result: Result) => {
        if (result.Success) {
          if (result.Message === "google") {
            this.adType = AdType.Google;
            this.googleCreatives = result.Data as GoogleCreatives;
          } else {
            this.adType = AdType.Facebook;
            this.facebookAd = result.Data as string;
          }
        } else {
          HelperService.showError(result.Message);
          this.close();
        }
      })
      .finally(() => {
        loader.hide();
      });
  }

  close(): void {
    this.$emit("close");
  }
}

enum AdType {
  None,
  Google,
  Facebook,
}
</script>

<style>
.metric-column._ngcontent-rsq-30 .comparison-stat._ngcontent-rsq-30 .trend-up._ngcontent-rsq-30,
.metric-column._ngcontent-rsq-30 .comparison-stat._ngcontent-rsq-30 .trend-down._ngcontent-rsq-30 {
  display: inline-block;
  height: 12px;
  left: 0;
  position: relative;
  width: 12px;
}

.metric-column._ngcontent-rsq-30 .comparison-stat._ngcontent-rsq-30 .trend-up._ngcontent-rsq-30:before,
.metric-column._ngcontent-rsq-30 .comparison-stat._ngcontent-rsq-30 .trend-down._ngcontent-rsq-30:before {
  border: 5px solid transparent;
  content: "";
  left: 0;
  position: absolute;
}

.metric-column._ngcontent-rsq-30 .comparison-stat._ngcontent-rsq-30 .trend-up._ngcontent-rsq-30:after,
.metric-column._ngcontent-rsq-30 .comparison-stat._ngcontent-rsq-30 .trend-down._ngcontent-rsq-30:after {
  content: "";
  display: inline-block;
  height: 8px;
  left: 4px;
  position: absolute;
}

.card-frame._ngcontent-rsq-30 {
  font-size: 13px;
  font-weight: 400;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  background: #fff;
  border-radius: 2px;
  cursor: default;
  display: flex;
  flex-direction: column;
  margin: 8px;
  padding: 0;
  position: relative;
  width: 488px;
}

.card-frame.double-width._ngcontent-rsq-30 {
  width: 992px;
}

.card-header._ngcontent-rsq-30 {
  -ms-flex-pack: justify;
  -webkit-flex-align: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  background: #fff;
  border-radius: 2px 2px 0 0;
  display: flex;
  height: 72px;
}

.card-header._ngcontent-rsq-30 .card-info._ngcontent-rsq-30 {
  display: flex;
  overflow: hidden;
}

.card-header._ngcontent-rsq-30 .card-info._ngcontent-rsq-30 .card-details-link._ngcontent-rsq-30 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-header._ngcontent-rsq-30 .card-options._ngcontent-rsq-30 {
  display: flex;
  flex-direction: row-reverse;
}

h1._ngcontent-rsq-30 {
  color: rgba(0, 0, 0, 0.87);
  cursor: default;
  font-size: 18px;
  font-weight: 400;
  margin: 0;
  padding: 20px 8px 0 16px;
}

.card-details-link:hover._ngcontent-rsq-30 {
  color: #3367d6;
  cursor: pointer;
}

.card-tooltip._ngcontent-rsq-30 {
  padding-top: 20px;
}

.card-tooltip._ngcontent-rsq-30 help-tooltip-icon._ngcontent-rsq-30 .material-icon-i.material-icon-i {
  font-size: 20px;
}

.card-content._ngcontent-rsq-30 {
  flex: 1;
  position: relative;
}

.card-content.padded._ngcontent-rsq-30 {
  padding: 0 16px 16px;
}

.card-footer._ngcontent-rsq-30 {
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  box-shadow: inset 0 1px #e0e0e0;
  display: flex;
  justify-content: space-between;
  height: 48px;
  padding: 8px;
}

.card-footer._ngcontent-rsq-30 .button._ngcontent-rsq-30 {
  color: #3367d6;
  text-transform: uppercase;
  line-height: 15px;
}

.card-footer._ngcontent-rsq-30 .button._ngcontent-rsq-30 material-icon._ngcontent-rsq-30 {
  height: 15px;
}

.hide._ngcontent-rsq-30 {
  display: none;
}

.no-data._ngcontent-rsq-30 {
  left: 0;
  position: absolute;
  right: 0;
  text-align: center;
  top: 50%;
}

.card-frame._ngcontent-rsq-30 {
  position: relative;
}

.card-header._ngcontent-rsq-30 {
  height: 48px;
}

.card-content:not(.metric-picker-opened)._ngcontent-rsq-30 {
  overflow: hidden;
}

.ad._ngcontent-rsq-30 {
  font-size: 13px;
  font-family: arial, sans-serif;
  line-height: 19px;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: center;
  justify-content: center;
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  cursor: default;
  transition: box-shadow cubic-bezier(0, 0, 0.2, 1) 218ms;
}

.ad.smaller._ngcontent-rsq-30 {
  font-size: 12px;
  font-family: arial, sans-serif;
  line-height: 19px;
}

.ad.sitelink-suggestion-mode._ngcontent-rsq-30 {
  background-color: #e0e0e0;
}

.adgroup-name._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-justify-content: center;
  justify-content: center;
  padding: 0 16px 8px;
}

.adgroup-name._ngcontent-rsq-30 .adgroup-link._ngcontent-rsq-30 {
  color: #3367d6;
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.adgroup-name._ngcontent-rsq-30 .adgroup-link:hover._ngcontent-rsq-30 {
  cursor: pointer;
  text-decoration: underline;
}

.adgroup-name._ngcontent-rsq-30 .adgroup-label._ngcontent-rsq-30 {
  color: rgba(0, 0, 0, 0.87);
  padding-right: 4px;
  white-space: nowrap;
}

.ad-carousel-frame._ngcontent-rsq-30 {
  overflow: hidden;
  width: 488px;
}

.ad-carousel._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -ms-flex-positive: 1;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  transition: margin-left cubic-bezier(0, 0, 0.2, 1) 436ms;
  width: 4880px;
}

.ad-carousel._ngcontent-rsq-30 .ad-carousel-item._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  padding-bottom: 5px;
  max-height: 188px;
  transition: max-height cubic-bezier(0, 0, 0.2, 1) 218ms;
  width: 488px;
}

.ad-carousel._ngcontent-rsq-30 .ad-carousel-item.adgroup-label-present._ngcontent-rsq-30 {
  max-height: 180px;
}

.ad-carousel._ngcontent-rsq-30 .ad-carousel-item.adgroup-label-present.ad-hovered._ngcontent-rsq-30 {
  height: 304px;
  max-height: 304px;
}

.ad-carousel._ngcontent-rsq-30 .ad-carousel-item.ad-hovered._ngcontent-rsq-30 {
  max-height: 328px;
}

.ad-carousel._ngcontent-rsq-30 .ad-carousel-item.ad-hovered._ngcontent-rsq-30 .sitelink-extensions._ngcontent-rsq-30,
.ad-carousel._ngcontent-rsq-30 .ad-carousel-item.ad-hovered._ngcontent-rsq-30 .one-line-text-extension._ngcontent-rsq-30,
.ad-carousel._ngcontent-rsq-30 .ad-carousel-item.ad-hovered._ngcontent-rsq-30 .call-extension._ngcontent-rsq-30 {
  opacity: 1;
}

.device._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -ms-flex-positive: 1;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  transition: background-color cubic-bezier(0, 0, 0.2, 1) 436ms, border-color cubic-bezier(0, 0, 0.2, 1) 436ms,
    margin cubic-bezier(0, 0, 0.2, 1) 436ms, padding cubic-bezier(0, 0, 0.2, 1) 436ms;
}

.metrics-container._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  padding: 8px 16px 0;
  width: 456px;
}

.metrics-container._ngcontent-rsq-30 .metric-wrapper._ngcontent-rsq-30 {
  position: relative;
}

.ad-icon._ngcontent-rsq-30 {
  font-size: 12px;
  font-weight: 400;
  border-radius: 2px;
  border: 1px solid #006621;
  color: #006621;
  display: inline-block;
  line-height: 14px;
  margin-right: 7px;
  padding: 0 2px;
  vertical-align: baseline;
}

.ad-icon:not(.sitelink-suggestion-mode)._ngcontent-rsq-30 {
  background: #fff;
}

.ad-icon.sitelink-suggestion-mode._ngcontent-rsq-30 {
  background-color: #e0e0e0;
}

.ad-preview-header._ngcontent-rsq-30 {
  font-size: 18px;
  font-weight: normal;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.header-link._ngcontent-rsq-30 {
  color: #1a0dab;
  display: block;
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
}

.header-link:hover._ngcontent-rsq-30 {
  cursor: pointer;
  text-decoration: underline;
}

.subheader._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
}

.description._ngcontent-rsq-30 {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  color: #545454;
  margin-right: 2px;
  overflow: hidden;
}

.display-url._ngcontent-rsq-30 {
  font-size: 14px;
  font-weight: normal;
  color: #006621;
  min-height: 19px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.display-url.smaller._ngcontent-rsq-30 {
  font-size: 13px;
  font-weight: normal;
}

.sitelink-extensions._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  opacity: 0.3;
  transition: opacity cubic-bezier(0, 0, 0.2, 1) 436ms;
}

.sitelink-extensions.sitelink-suggestion-mode._ngcontent-rsq-30 {
  background-color: #fff;
}

.one-line-text-extension._ngcontent-rsq-30,
.call-extension._ngcontent-rsq-30 {
  opacity: 0.3;
  transition: opacity cubic-bezier(0, 0, 0.2, 1) 436ms;
}

.sitelink-text._ngcontent-rsq-30 {
  color: #1a0dab;
  cursor: default;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background-color cubic-bezier(0, 0, 0.2, 1) 218ms;
  white-space: nowrap;
}

.sitelink-text:hover._ngcontent-rsq-30 {
  cursor: pointer;
  text-decoration: underline;
}

.desktop-device._ngcontent-rsq-30 {
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.desktop-device._ngcontent-rsq-30 .sitelink._ngcontent-rsq-30 {
  overflow: hidden;
  width: 50%;
}

.desktop-device._ngcontent-rsq-30 .ad._ngcontent-rsq-30 {
  outline: 1px solid whitesmoke;
  padding: 8px;
}

.desktop-device.device._ngcontent-rsq-30 {
  background-color: #fff;
  border-color: #fff;
  margin: 0;
  padding: 8px 8px 0;
}

.desktop-device._ngcontent-rsq-30 .ad-preview-header._ngcontent-rsq-30 {
  font-size: 18px;
  font-weight: normal;
}

.desktop-device._ngcontent-rsq-30 .ad-preview-header._ngcontent-rsq-30 a._ngcontent-rsq-30 {
  white-space: nowrap;
}

.desktop-device._ngcontent-rsq-30 .ad-preview-header.smaller._ngcontent-rsq-30 {
  font-size: 15px;
  font-weight: normal;
}

.desktop-device._ngcontent-rsq-30 .header-link._ngcontent-rsq-30 {
  white-space: nowrap;
}

.desktop-device._ngcontent-rsq-30 .display-url-container._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  max-width: 456px;
}

.desktop-device._ngcontent-rsq-30 .url-container._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  max-width: 456px;
}

.desktop-device._ngcontent-rsq-30 .description._ngcontent-rsq-30 {
  white-space: normal;
}

.desktop-device._ngcontent-rsq-30 .call-extension._ngcontent-rsq-30 {
  color: #545454;
  margin-left: 8px;
}

.desktop-device._ngcontent-rsq-30 .phone-number._ngcontent-rsq-30 {
  font-size: 13px;
  font-weight: normal;
  white-space: nowrap;
}

.desktop-device._ngcontent-rsq-30 .sitelink-text._ngcontent-rsq-30 {
  margin-left: 24px;
}

.desktop-device._ngcontent-rsq-30 .subheader-item._ngcontent-rsq-30 {
  max-width: 456px;
}

.desktop-device._ngcontent-rsq-30 .one-line-text-extension._ngcontent-rsq-30 {
  color: #545454;
}

.mobile-device._ngcontent-rsq-30 {
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  border-style: solid;
  border-top-left-radius: 32px;
  border-top-right-radius: 32px;
  border-width: 32px 16px 0;
  position: relative;
}

.mobile-device._ngcontent-rsq-30 .sitelink-extensions._ngcontent-rsq-30 {
  flex-direction: column;
}

.mobile-device._ngcontent-rsq-30 .sitelink-extensions._ngcontent-rsq-30 .sitelink._ngcontent-rsq-30 {
  padding-bottom: 4px;
}

.mobile-device._ngcontent-rsq-30 .header-wrapper._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
}

.mobile-device._ngcontent-rsq-30 .header-wrapper._ngcontent-rsq-30 .call-icon._ngcontent-rsq-30 {
  color: #1a0dab;
}

.mobile-device._ngcontent-rsq-30 .inner-frame._ngcontent-rsq-30 {
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #e0e0e0;
  border-bottom-width: 0;
  bottom: 0;
  left: 4px;
  position: absolute;
  right: 4px;
  top: 0;
  transition: border-color cubic-bezier(0, 0, 0.2, 1) 218ms;
}

.mobile-device._ngcontent-rsq-30 .outer-frame._ngcontent-rsq-30 {
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border: 4px solid #e0e0e0;
  border-bottom-width: 0;
  border-top-left-radius: 32px;
  border-top-right-radius: 32px;
  bottom: 0;
  left: -12px;
  position: absolute;
  right: -12px;
  top: -32px;
  transition: border-color cubic-bezier(0, 0, 0.2, 1) 218ms;
}

.mobile-device._ngcontent-rsq-30 .description._ngcontent-rsq-30 {
  font-size: 13px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.87);
  overflow: hidden;
}

.mobile-device._ngcontent-rsq-30 .description.smaller._ngcontent-rsq-30 {
  font-size: 13px;
}

.mobile-device._ngcontent-rsq-30 .camera._ngcontent-rsq-30 {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 100%;
  height: 8px;
  left: 0;
  margin: -32px auto 16px;
  position: absolute;
  right: 0;
  top: 12px;
  transition: border-color cubic-bezier(0, 0, 0.2, 1) 218ms;
  width: 8px;
}

.mobile-device._ngcontent-rsq-30 .mobile-ad-card._ngcontent-rsq-30 {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  margin: 8px;
  margin-top: 0;
  padding: 12px;
  position: relative;
  transition: box-shadow cubic-bezier(0, 0, 0.2, 1) 218ms;
}

.mobile-device.device._ngcontent-rsq-30 {
  border-color: #fff;
  margin: auto 48px;
  padding: 8px 4px 0;
}

.mobile-device._ngcontent-rsq-30 .ad-preview-header._ngcontent-rsq-30 {
  font-size: 16px;
  font-weight: normal;
  width: 312px;
}

.mobile-device._ngcontent-rsq-30 .ad-preview-header._ngcontent-rsq-30 a._ngcontent-rsq-30 {
  white-space: normal;
}

.mobile-device._ngcontent-rsq-30 .ad-preview-header.smaller._ngcontent-rsq-30 {
  font-size: 15px;
  font-weight: normal;
}

.mobile-device._ngcontent-rsq-30 .mobile-divider._ngcontent-rsq-30 {
  border-bottom: 1px solid #eee;
  margin: 8px -8px;
}

.mobile-device._ngcontent-rsq-30 .subheader._ngcontent-rsq-30 {
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.mobile-device._ngcontent-rsq-30 .display-url-container._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  width: 312px;
}

.mobile-device._ngcontent-rsq-30 .description-container._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
}

.mobile-device._ngcontent-rsq-30 .description-sub-container._ngcontent-rsq-30 {
  -ms-flex-positive: 1;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  max-width: 100%;
  min-width: 50%;
}

.mobile-device._ngcontent-rsq-30 .extension-after-description._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
}

.tablet-device._ngcontent-rsq-30 {
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  border-style: solid;
  border-width: 24px 24px 0;
  position: relative;
}

.tablet-device._ngcontent-rsq-30 .sitelink-extensions._ngcontent-rsq-30 {
  flex-direction: column;
}

.tablet-device._ngcontent-rsq-30 .sitelink-extensions._ngcontent-rsq-30 .sitelink._ngcontent-rsq-30 {
  padding-bottom: 4px;
}

.tablet-device._ngcontent-rsq-30 .call-extension._ngcontent-rsq-30 {
  color: #545454;
  margin-left: 8px;
}

.tablet-device._ngcontent-rsq-30 .inner-frame._ngcontent-rsq-30 {
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #e0e0e0;
  border-bottom-width: 0;
  bottom: 0;
  left: 4px;
  position: absolute;
  right: 4px;
  top: 8px;
  transition: border-color cubic-bezier(0, 0, 0.2, 1) 218ms;
}

.tablet-device._ngcontent-rsq-30 .outer-frame._ngcontent-rsq-30 {
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border: 4px solid #e0e0e0;
  border-bottom-width: 0;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  bottom: 0;
  left: -16px;
  position: absolute;
  right: -16px;
  top: -16px;
  transition: border-color cubic-bezier(0, 0, 0.2, 1) 218ms;
}

.tablet-device._ngcontent-rsq-30 .description._ngcontent-rsq-30 {
  font-size: 13px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.87);
  overflow: hidden;
}

.tablet-device._ngcontent-rsq-30 .description.smaller._ngcontent-rsq-30 {
  font-size: 13px;
}

.tablet-device._ngcontent-rsq-30 .tablet-ad-card._ngcontent-rsq-30 {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  margin: 8px;
  margin-top: 0;
  padding: 12px;
  position: relative;
  transition: box-shadow cubic-bezier(0, 0, 0.2, 1) 218ms;
}

.tablet-device.device._ngcontent-rsq-30 {
  border-color: #fff;
  margin: auto 8px;
  padding: 16px 4px 0;
}

.tablet-device._ngcontent-rsq-30 .ad-preview-header._ngcontent-rsq-30 {
  font-size: 16px;
  font-weight: normal;
}

.tablet-device._ngcontent-rsq-30 .ad-preview-header._ngcontent-rsq-30 a._ngcontent-rsq-30 {
  white-space: normal;
}

.tablet-device._ngcontent-rsq-30 .ad-preview-header.smaller._ngcontent-rsq-30 {
  font-size: 15px;
  font-weight: normal;
}

.tablet-device._ngcontent-rsq-30 .tablet-divider._ngcontent-rsq-30 {
  border-bottom: 1px solid #eee;
  margin: 8px -8px;
}

.tablet-device._ngcontent-rsq-30 .subheader._ngcontent-rsq-30 {
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.tablet-device._ngcontent-rsq-30 .subheader-item._ngcontent-rsq-30 {
  max-width: 376px;
}

.tablet-device._ngcontent-rsq-30 .display-url-container._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  width: 376px;
}

.tablet-device._ngcontent-rsq-30 .sitelink-text._ngcontent-rsq-30 {
  margin-right: 8px;
}

.tablet-device._ngcontent-rsq-30 .description-container._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
}

.tablet-device._ngcontent-rsq-30 .description-sub-container._ngcontent-rsq-30 {
  max-width: 100%;
}

.tablet-device._ngcontent-rsq-30 .extension-after-description._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
}

.tablet-device._ngcontent-rsq-30 .phone-number._ngcontent-rsq-30 {
  font-size: 13px;
  font-weight: normal;
  white-space: nowrap;
}

.tablet-device._ngcontent-rsq-30 .url-container._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  flex-direction: row;
  max-width: 376px;
}

.pickers-container._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  -webkit-align-items: baseline;
  align-items: baseline;
}

.stat-metric._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  color: rgba(0, 0, 0, 0.54);
  height: 24px;
  text-align: left;
}

._nghost-rsq-30 metric-picker .metric-selector {
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
}

.stats._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: baseline;
  align-items: baseline;
  cursor: default;
}

.metric-column._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}

.metric-column._ngcontent-rsq-30 .stat-value._ngcontent-rsq-30 {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
  height: 24px;
}

.metric-column._ngcontent-rsq-30 .comparison-stat._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-align-items: baseline;
  align-items: baseline;
}

.metric-column._ngcontent-rsq-30 .comparison-stat._ngcontent-rsq-30 .trend-up._ngcontent-rsq-30 {
  -moz-transform: scale(1, 1);
  -ms-transform: scale(1, 1);
  -webkit-transform: scale(1, 1);
  transform: scale(1, 1);
  top: -2px;
}

.metric-column._ngcontent-rsq-30 .comparison-stat._ngcontent-rsq-30 .trend-up._ngcontent-rsq-30:before {
  border-bottom-color: #757575;
  top: -4px;
}

.metric-column._ngcontent-rsq-30 .comparison-stat._ngcontent-rsq-30 .trend-up._ngcontent-rsq-30:after {
  border: 1px solid #757575;
  bottom: 0;
}

.metric-column._ngcontent-rsq-30 .comparison-stat._ngcontent-rsq-30 .trend-down._ngcontent-rsq-30 {
  -moz-transform: scale(1, 1);
  -ms-transform: scale(1, 1);
  -webkit-transform: scale(1, 1);
  transform: scale(1, 1);
  top: 0;
}

.metric-column._ngcontent-rsq-30 .comparison-stat._ngcontent-rsq-30 .trend-down._ngcontent-rsq-30:before {
  border-top-color: #757575;
  top: 6px;
}

.metric-column._ngcontent-rsq-30 .comparison-stat._ngcontent-rsq-30 .trend-down._ngcontent-rsq-30:after {
  border: 1px solid #757575;
  top: 0;
}

.ad-header-measurement-frame._ngcontent-rsq-30 {
  height: 0;
  overflow: hidden;
  position: absolute;
}

.ad-header-measurement-exact._ngcontent-rsq-30,
.ad-header-measurement-smaller._ngcontent-rsq-30 {
  font-family: arial, sans-serif;
  white-space: normal;
  width: 456px;
}

.ad-header-measurement-exact.mobile-header._ngcontent-rsq-30,
.ad-header-measurement-smaller.mobile-header._ngcontent-rsq-30 {
  width: 312px;
}

.ad-header-measurement-exact.tablet-header._ngcontent-rsq-30,
.ad-header-measurement-smaller.tablet-header._ngcontent-rsq-30 {
  width: 376px;
}

.ad-header-measurement-exact._ngcontent-rsq-30 {
  font-size: 18px;
  font-weight: normal;
}

.ad-header-measurement-exact.mobile-header._ngcontent-rsq-30,
.ad-header-measurement-exact.tablet-header._ngcontent-rsq-30 {
  font-size: 16px;
  font-weight: normal;
}

.ad-header-measurement-smaller._ngcontent-rsq-30 {
  font-size: 15px;
  font-weight: normal;
}

.bold._ngcontent-rsq-30 {
  font-weight: bold;
}

.ad-hovered._ngcontent-rsq-30 .inner-frame._ngcontent-rsq-30,
.ad-hovered._ngcontent-rsq-30 .outer-frame._ngcontent-rsq-30,
.ad-hovered._ngcontent-rsq-30 .camera._ngcontent-rsq-30 {
  border-color: #bdbdbd;
}

.one-line-text-extension._ngcontent-rsq-30 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.call-mobile-divider._ngcontent-rsq-30 {
  border-bottom: 1px solid #eee;
  margin: 8px -12px;
}

.call-mobile._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  color: #545454;
}

.call-icon._ngcontent-rsq-30 {
  padding-right: 16px;
}

.inline-editor._ngcontent-rsq-30 {
  background: #fff;
  bottom: 0;
  height: 0;
  overflow: hidden;
  position: absolute;
  transition: height 436ms cubic-bezier(0, 0, 0.2, 1);
  width: inherit;
}

.inline-editor.visible._ngcontent-rsq-30 {
  height: 376px;
}

.ad-status-container._ngcontent-rsq-30 {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  position: relative;
}

entity-status-editor._ngcontent-rsq-30 .current-status {
  margin-left: -16px;
}

.ad-status-container._ngcontent-rsq-30 .enabled._ngcontent-rsq-30 {
  background-color: #0f9d58;
  border-radius: 50%;
  height: 12px;
  width: 12px;
}

.ad-status-container._ngcontent-rsq-30 .paused._ngcontent-rsq-30 {
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiIgd2lkdGg9IjEycHgiIGhlaWdodD0iMTJweCI+CjxwYXRoIGZpbGw9IiM3NTc1NzUiIGQ9Ik02LDBDMi42LDAsMCwyLjYsMCw2czIuNiw2LDYsNnM2LTIuNyw2LTZTOS4zLDAsNiwweiBNNS40LDguNEg0LjJWMy42aDEuMkw1LjQsOC40TDUuNCw4LjR6IE03LjgsOC40SDYuNgpWMy42aDEuMkM3LjgsMy42LDcuOCw4LjQsNy44LDguNHoiLz4KPC9zdmc+Cg==");
  background-color: transparent;
  background-size: 12px 12px;
  width: 12px;
  height: 12px;
}

.ad-status-container._ngcontent-rsq-30 .removed._ngcontent-rsq-30 {
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiIgd2lkdGg9IjEycHgiIGhlaWdodD0iMTJweCI+CjxwYXRoIGZpbGw9IiNDNTM5MjkiIGQ9Ik02LDEyYzMuNCwwLDYtMi42LDYtNlM5LjQsMCw2LDBTMCwyLjcsMCw2UzIuNywxMiw2LDEyeiBNMy4zLDQuM2wxLTFMNS45LDVsMS43LTEuN2wxLDFMNyw2bDEuNywxLjdsLTEsMQpMNiw3TDQuMyw4LjZsLTEtMUw1LDZMMy4zLDQuM3oiLz4KPC9zdmc+Cg==");
  background-color: transparent;
  background-size: 12px 12px;
  width: 12px;
  height: 12px;
}

.ad-status-container._ngcontent-rsq-30 .ad-status._ngcontent-rsq-30 {
  font-size: 14px;
  padding-left: 4px;
}

.suggestion-sitelink-footer._ngcontent-rsq-30 {
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  justify-content: space-between;
  box-shadow: inset 0 1px #e0e0e0;
  padding: 8px;
}

.suggestion-sitelink-footer._ngcontent-rsq-30 .button._ngcontent-rsq-30 {
  color: #3367d6;
  text-transform: uppercase;
}

.suggestion-sitelink-action._ngcontent-rsq-30 {
  color: #4285f4;
}

.recommendation-container._ngcontent-rsq-30 {
  display: flex;
  justify-content: center;
}

.recommendation-center-container._ngcontent-rsq-30 {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 16px;
  background-color: #e8f0fe;
  border: 2px dotted #c6dafc;
  border-radius: 8px;
  width: 100%;
}

.recommendation-button._ngcontent-rsq-30 {
  color: #3367d6;
  display: flex;
  width: fit-content;
}

.recommendation-message._ngcontent-rsq-30 {
  font-weight: 700;
  margin-left: 8px;
}

.card-footer._ngcontent-rsq-30 {
  overflow: hidden;
  transition: height 436ms cubic-bezier(0, 0, 0.2, 1);
}

.card-footer.ad-hovered._ngcontent-rsq-30 {
  height: 0;
  padding-bottom: 0;
  padding-top: 0;
}
</style>
